import Password from './password';

interface Props {
  /**
   * The password that the confirmed password must match
   */
  mustMatch: string;
}

const ConfirmPassword: React.FC<
  Props & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = ({ mustMatch, ...props }) => (
  <Password
    {...props}
    isNew={false}
    onChange={e => e.target.setCustomValidity(e.target.value === mustMatch ? '' : 'Passwords do not match')}
  />
);

export default ConfirmPassword;
